// extracted by mini-css-extract-plugin
export default {"container":"meterDetails_container__094vl","content":"meterDetails_content__4mVU3","description":"meterDetails_description__YHmP7"};